import {
  Component,
  Input,
  OnInit,
  inject,
  Output,
  ViewChild,
  EventEmitter,
} from '@angular/core';
import {
  DxButtonComponent,
  DxCheckBoxComponent,
  DxDataGridComponent,
  DxDateBoxComponent,
  DxLoadPanelComponent,
  DxLookupComponent,
  DxPopupComponent,
  DxTextBoxComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';
import notify from 'devextreme/ui/notify';
import { Dipendente } from 'src/app/models/dipendente';
import { DipendenteChangeModel } from 'src/app/models/dipendente-change-model';
import { Mansioni } from 'src/app/models/mansioni';
import { ModelliMansioni } from 'src/app/models/modelli-mansioni';
import { Reparti } from 'src/app/models/reparti';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { MansioniService } from 'src/app/shared/services/mansioni.service';
import { ModelliMansioniService } from 'src/app/shared/services/modelli-mansioni.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { RepartiService } from 'src/app/shared/services/reparti.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';
import { PopupBarCodeComponent } from '../../popups/popup-barcode/popup-barcode.component';
import { PrintBarCodeModel } from 'src/app/models/print-barcode-model';

@Component({
  selector: 'app-form-dipendente',
  templateUrl: './form-dipendente.component.html',
  styleUrls: ['./form-dipendente.component.scss'],
  imports: [
    DxTextBoxComponent,
    DxDateBoxComponent,
    DxCheckBoxComponent,
    DxValidatorComponent,
    DxButtonComponent,
    DxLookupComponent,
    DxiValidationRuleComponent,
    DxLoadPanelComponent,
    PopupBarCodeComponent,
    DxPopupComponent
  ],
  standalone: true,
})
export class FormDipendenteComponent implements OnInit {
  private dipendentiS = inject(DipendentiService);
  private repartiService = inject(RepartiService);
  private nS = inject(NavigatorService);
  private modManService = inject(ModelliMansioniService);
  private mansioniService = inject(MansioniService);
  private tipiArticoliService = inject(TipiArticoliService);
  @ViewChild('dettModArtGrid', { static: false })
  dettModArtGrid: DxDataGridComponent;
  popupInfoBarCode: boolean = false;

  @Input() idDipendente: number;
  @Output() dataDipendenteEventEmitter = new EventEmitter<boolean>();

  dipendente: Dipendente;
  isNew: boolean;
  codiceFiscalePattern: any =
    /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]+$/;
  listReparti: Reparti[];
  listMansioni: Mansioni[];
  listModMan: ModelliMansioni[];
  listModManFilterd: ModelliMansioni[];
  listDipendenti: any;
  listTipiArticoli: TipiArticoli[];
  idMansioneOrig = 0;
  rimuoviArtManPrec = false;
  loadPanelVisible: boolean = false;

  printBarcodeModel : PrintBarCodeModel = new PrintBarCodeModel();

  ngOnInit() {
    console.log('idDipendente: ' + this.idDipendente);
    this.isNew = true;
    if (this.idDipendente > 0) {
      this.isNew = false;
    }

    this.loadLookups();

    this.getDipendente();
  }

  loadLookups() {
    this.repartiService.listTemp().subscribe({
      next: (res) => {
        this.listReparti = res;
      }
    });

    this.tipiArticoliService.list().subscribe({
      next: (res) => {
        this.listTipiArticoli = res;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento tipi articoli', 'warning');
        }
      },
    });

    this.modManService.list().subscribe({
      next: (res) => {
        this.listModMan = res;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento modelli mansioni', 'warning');
        }
      },
    });

    this.mansioniService.list().subscribe({
      next: (res) => {
        this.listMansioni = res;
      },
      error: (error) => {
        console.error('Errore caricamento mansioni: ' + error);
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento mansioni', 'warning');
        }
      },
    });

    this.dipendentiS.list().subscribe({
      next: (res) => {
        this.listDipendenti = {
          store: {
            type: 'array',
            data: res,
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento dipendenti', 'warning');
        }
      },
    });
  }

  onMansioneValueChanged() {
    //this.listModManFilterd = this.listModMan.filter(m => m.idMansione == e.value); //Disattiva Novembre 2025
  }

  getDipendente() {
    this.dipendente = new Dipendente();

    if (this.idDipendente > 0) {
      this.dipendentiS.get(this.idDipendente).subscribe((dati) => {
        // console.log('id dip form:' +this.idDipendente);
        if (dati != null) {
          this.dipendente = dati;
          this.idMansioneOrig = dati.idMansione;
          //  this.anagraDB = this.cloneObj(this.anagra);
        } else {
          //console.log('Dipendente ' + this.idDipendente + ' non presente');
          //notify(`Ospite non presente!`, 'warning', 1000);
          this.nS.goToHome();
        }
      });
    }
  }

  //Button "Salva"
  SalvaDipendente = (e) => {
    this.loadPanelVisible = true;
    const result = e.validationGroup.validate();
    if (result.isValid) {
      // Submit values to the server
      // console.log('valori:' + JSON.stringify(this.dipendente));

      //Data Assunzione
      if (this.dipendente.dataAssunzione != null) {
        const data = new Date(this.dipendente.dataAssunzione);
        const realDay = data.getDate();
        const realMonth = data.getMonth();
        const realYear = data.getFullYear();
        this.dipendente.dataAssunzione = new Date(
          Date.UTC(realYear, realMonth, realDay),
        );
      }

      //Data Licenziamento
      if (this.dipendente.dataLicenziamento != null) {
        const data = new Date(this.dipendente.dataLicenziamento);
        const realDay = data.getDate();
        const realMonth = data.getMonth();
        const realYear = data.getFullYear();
        this.dipendente.dataLicenziamento = new Date(
          Date.UTC(realYear, realMonth, realDay),
        );
      }

      //Data Nascita
      if (this.dipendente.dataNascita != null) {
        const data = new Date(this.dipendente.dataNascita);
        const realDay = data.getDate();
        const realMonth = data.getMonth();
        const realYear = data.getFullYear();
        this.dipendente.dataNascita = new Date(
          Date.UTC(realYear, realMonth, realDay),
        );
      }
      const idArtSelected = this.dettModArtGrid?.instance
        .getSelectedRowsData()
        .map((a) => a.idArticolo);
      const dipChangeModel = new DipendenteChangeModel();
      dipChangeModel.dipendente = this.dipendente;
      dipChangeModel.idArticoliDett = idArtSelected;
      dipChangeModel.rimuoviDettPrecedente = this.rimuoviArtManPrec;

      if (this.idDipendente > 0) {
        //Modifica
        //console.log('Modifica id:' + this.dipendente.id);

        this.dipendentiS.update(this.dipendente.id, dipChangeModel).subscribe({
          next: (res) => {
            if (res.id > 0) {
              this.dipendentiS.listTemp(true).subscribe();//Aggiorno la lista dei dipendenti
              //this.valMod= false;
              //this.anagraDB = this.cloneObj(this.anagra);
              this.loadPanelVisible = false;
              //notify({ message: "Dipendente aggiornato", width: 300, shading: true, type:"success" });
              notificaMessaggio('Didendente aggiornato', 'success');
              this.idMansioneOrig = dipChangeModel.dipendente.idMansione;
              this.dataDipendenteEventEmitter.emit(true);
            } else {
              this.loadPanelVisible = false;
              notify('Errore aggiornamento dati dipendente', 'error', 1000);
            }
          },
          error: (err) => {
            //console.log('HTTP Error', err),
            this.loadPanelVisible = false;
            notify(err.error.title, 'warning', 5000);
          },
        });
      } else {
        //Nuovo

        const data = new Date();
        const realDay = data.getDate();
        const realMonth = data.getMonth();
        const realYear = data.getFullYear();

        dipChangeModel.dipendente.dataCreazione = new Date(
          Date.UTC(realYear, realMonth, realDay),
        );

        this.dipendentiS.post(dipChangeModel).subscribe({
          next: (res) => {
            if (res.id > 0) {
              this.loadPanelVisible = false;
              this.dipendentiS.listTemp(true).subscribe(); //Aggiorno la lista dei dipendenti
              //notify({ message: "Nuovo dipendente inserito", width: 300, shading: true, type:"success" });
              notificaMessaggio('Nuovo dipendente inserito', 'success');
              //Go to pagina di dettaglio
              this.nS.goToDipendentiDetail(res.id);
            } else {
              this.loadPanelVisible = false;
              notify('Errore inserimento nuovo dipendente', 'warning', 3000);
            }
          },
          error: (err) => {
            //console.log('HTTP Error', err),
            this.loadPanelVisible = false;
            notify(err.error.title, 'warning', 5000);
          },
        });
      }
    } else {
      this.loadPanelVisible = false;
      //notify(`Salvataggio non eseguito. Verifica di aver compilato correttamente i campi`, 'warning', 2000);
      notificaMessaggio(
        'Salvataggio non eseguito. Verifica di aver compilato correttamente i campi',
        'warning',
      );
    }
  };

  AttivaDisattiva(valore: boolean) {
    this.dipendentiS
      .attivaDisattiva(this.dipendente.id, valore, this.dipendente)
      .subscribe({
        next: () => {
          this.dipendentiS.listTemp(true).subscribe();//Aggiorno la lista dei dipendenti
          this.dipendente.attivo = valore;
          //notify(`Aggiornamento dipendente eseguito`, 'success', 3000);
          notificaMessaggio('Aggiornamento dipendente eseguito', 'success');
        },
        error: (err) => {
          console.log('HTTP Error', err);
          notify(err.error.title, 'warning', 5000);
        },
      });
  }

  getRepartoDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return (
      item.codice +
      ' - ' +
      item.descrizione +
      (item.sito?.descrizione?.length > 0
        ? ' (' + item.sito.descrizione + ')'
        : '')
    );
  }

  getResponsabileDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.nominativo;
  }

  getMansioneDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.descrizione;
  }

  calculateCellValueArticolo(item) {
    if (!item.articolo) {
      return '';
    }

    return (
      item.articolo.codice +
      ' - ' +
      item.articolo.descrizione +
      (item.articolo.taglia ? ' - ' + item.articolo.taglia : '')
    );
  }

  stampaEtichetta() {
    this.printBarcodeModel = new PrintBarCodeModel();
    this.printBarcodeModel.idsObject.push(this.idDipendente);
    this.popupInfoBarCode = true;
  }

  onPopupBarcodeEventEmitter(event){
    this.popupInfoBarCode = false;
    this.loadPanelVisible = true;
    this.printBarcodeModel.grande = event.grande;
    this.printBarcodeModel.numeroCopie = event.numeroCopie;
    this.dipendentiS.stampaEtichette(this.printBarcodeModel).subscribe({
      next: res=>{
        this.loadPanelVisible = false;
        const url = window.URL.createObjectURL(res);
        window.open(url);
      },
      error: err=>{
        this.loadPanelVisible = false;
        if(err?.error?.title){
          notificaMessaggio(err.error.title, "error");
        }
        else{
          notificaMessaggio("Errore stampa Etichetta", "error");
        }
      }
    })
  }
}
